/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_Voices_TitleInputs */

const en_dialog_premium_voices_title = /** @type {(inputs: Dialog_Premium_Voices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose from premium voices`)
};

const es_dialog_premium_voices_title = /** @type {(inputs: Dialog_Premium_Voices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige entre voces premium`)
};

/**
* | output |
* | --- |
* | "Choose from premium voices" |
*
* @param {Dialog_Premium_Voices_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_voices_title = /** @type {((inputs?: Dialog_Premium_Voices_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_Voices_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_voices_title(inputs)
	return en_dialog_premium_voices_title(inputs)
});